import {Component, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'app-update-tutorials-dialog',
    templateUrl: './update-tutorials-dialog.component.html',
    styleUrls: ['./update-tutorials-dialog.component.scss'],
    standalone: false
})
export class UpdateTutorialsDialogComponent {
    tutorialForm: FormGroup;
    isSubmitting = false;

    constructor(
        public dialogRef: MatDialogRef<UpdateTutorialsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: FormBuilder
    ) {
        // Initialize form with preserved content if available
        const initialContent = data?.content || '';
        this.tutorialForm = this.fb.group({
            content: [initialContent, [Validators.required, Validators.minLength(1)]]
        });
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onSubmit(): void {
        if (this.tutorialForm.valid && !this.isSubmitting) {
            this.isSubmitting = true;
            this.dialogRef.close(this.tutorialForm.value);
        }
    }
}